(function () {

    const accordion_selector = "[data-accordion]";
    const trigger_selector = "[data-accordion-trigger]";
    const panel_selector = "[data-accordion-panel]";

    const setAccordionState = (accordion, isOpen) => {
        const trigger = accordion.querySelector(trigger_selector);
        const panel = accordion.querySelector(panel_selector);

        if (!trigger || !panel) {
            return;
        }

        trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
        panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
        panel.hidden = !isOpen;
    };


    const initializeAccordion = (accordion) => {
        const trigger = accordion.querySelector(trigger_selector);

         if (!trigger) {
            return;
        }

        setAccordionState(accordion, trigger.getAttribute("aria-expanded") === "true");

        trigger.addEventListener("click", () => {
            setAccordionState(accordion, trigger.getAttribute("aria-expanded") !== "true");
        });
    }

    document.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll(accordion_selector).forEach(initializeAccordion);
    });


})();
